<template>
    <div/>
</template>

<script>
export default {
    computed: {
        catalogues() {
            return this.$store.getters['projects/project/extension/catalogue/catalogues']
        }
    },
    beforeMount() {
        this.$store.dispatch('projects/project/extension/catalogue/loadCatalogues')
            .then(() => {
                if (this.catalogues.length) {
                    const catalogue = this.catalogues[0];
                    this.$router.push({
                        name:   'project-extension-catalogue-set',
                        params: {catalogueId: catalogue.id}
                    })
                }
            });
    }
}
</script>
